<template>
    <a-layout>
        <Header>
            <a-button type="primary" icon="list" />
        </Header>
        <a-layout>
            <a-layout-sider width="180" style="background: #fff">
                <a-menu
                    mode="inline" :inlineIndent="16"
                    :selectedKeys="[ $route.name || '' ]"
                    :style="{ height: '100%', borderRight: 0 }"
                    @select="switchPanel"
                >
                    <a-menu-item key="home">
                        <a-icon type="home" />
                        <span>主页</span>
                    </a-menu-item>
                    <a-menu-item v-for="page of pages" :key="page.name">
                        <a-icon :type="page.icon" />
                        <span>{{ page.title }}</span>
                    </a-menu-item>
                </a-menu>
            </a-layout-sider>
            <a-layout style="padding: 0 24px 24px">
                <a-breadcrumb style="margin: 16px 0">
                    <a-breadcrumb-item>{{ $route.title }}</a-breadcrumb-item>
                </a-breadcrumb>
                <a-layout-content
                    :style="{ background: '#fff', padding: '24px', margin: 0, minHeight: '280px' }"
                >
                    <keep-alive>
                        <router-view/>
                    </keep-alive>
                </a-layout-content>
            </a-layout>
        </a-layout>
    </a-layout>
</template>

<script>
import Header from '@/components/header'
import { mapGetters } from 'vuex'

export default {
    name: 'App',
    data: () => ({
        //
    }),
    computed: {
        ...mapGetters('$privilege', [ "pages" ])
    },
    methods: {
        switchPanel({ key }) {
            this.$router.push({ name: key });
        }
    },
    components: {
        Header
    },
};
</script>
